import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as qs from 'qs';
import { EcondosQuery } from '../model/query';
import { environment } from '@environment';
import { SystemBroadcast } from '@api/model/system-broadcast';

@Injectable({ providedIn: 'root' })
export class SystemBroadcastService {
  private readonly endPoint = `${environment.backendUrl}system-broadcasts/`;

  constructor(protected http: HttpClient) {}

  get(query: EcondosQuery = {}): Observable<{ systemBroadcasts: SystemBroadcast[]; count: number }> {
    const params = new HttpParams({ fromString: qs.stringify(query) });
    return this.http.get<any>(this.endPoint, { params, observe: 'response' }).pipe(
      map(({ body: systemBroadcasts, headers }) => ({
        systemBroadcasts,
        count: parseInt(headers.get('count') || '0', 10)
      }))
    );
  }

  getActive(query: EcondosQuery = {}): Observable<{ systemBroadcasts: SystemBroadcast[]; count: number }> {
    const params = new HttpParams({ fromString: qs.stringify(query) });
    return this.http.get<any>(`${this.endPoint}active`, { params, observe: 'response' }).pipe(
      map(({ body: systemBroadcasts, headers }) => ({
        systemBroadcasts,
        count: parseInt(headers.get('count') || '0', 10)
      }))
    );
  }

  getById(systemBroadcastId: string, query: EcondosQuery = {}): Observable<SystemBroadcast> {
    const params = new HttpParams({ fromString: qs.stringify(query) });
    return this.http.get<SystemBroadcast>(`${this.endPoint}${systemBroadcastId}`, { params });
  }

  create(broadcast: Partial<SystemBroadcast>) {
    return this.http.post<Partial<SystemBroadcast>>(this.endPoint, broadcast);
  }

  update(systemBroadcastId: string, update: Partial<SystemBroadcast>) {
    return this.http.put<Partial<SystemBroadcast>>(`${this.endPoint}${systemBroadcastId}`, update);
  }

  delete(systemBroadcastId: SystemBroadcast['_id']) {
    return this.http.delete(`${this.endPoint}${systemBroadcastId}`);
  }

  toggle(systemBroadcastId: SystemBroadcast['_id']) {
    return this.http.put(`${this.endPoint}${systemBroadcastId}/toggle`, {});
  }
}
